import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const getSaleCertfication = (id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/certification/vehCertifications/sales/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_VEHICLE_CERTIFICATION_SALE,
        ActionTypes.FETCHED_VEHICLE_CERTIFICATION_SALE,
        [ActionTypes.FETCHED_VEHICLE_CERTIFICATION_SALE_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const getVehicleSaleRecord = (id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/certification/veh/sales/records/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_VEHICLE_RECORD_SALE,
        ActionTypes.FETCHED_VEHICLE_RECORD_SALE,
        [ActionTypes.FETCHED_VEHICLE_RECORD_SALE_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const getCertficationById = (id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/certification/vehCertification/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_VEHICLE_CERTIFICATION_BY_ID,
        [
          () => {
            dispatch(getSaleCertfication(id));
            dispatch(getVehicleSaleRecord(id));
            return {
              'type': ActionTypes.FETCHED_VEHICLE_CERTIFICATION_BY_ID,
            };
          },
        ],
        [ActionTypes.FETCHED_VEHICLE_CERTIFICATION_BY_ID_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};


export const saveCertificationSale = (data, id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/certification/vehCertifications/sales',
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_VEHICLE_CERTIFICATION_SALE,
        [
          () => {
            dispatch(getCertficationById(id));
            return {
              'type': ActionTypes.ADDED_VEHICLE_CERTIFICATION_SALE,
            };
          },
          (response) => buildSuccessMessage(response, 'Registros Guardados'),
        ],
        [ActionTypes.ADDED_VEHICLE_CERTIFICATION_SALE_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};


export const clearCertificationSale = () => {
  return {
    'type': ActionTypes.CLEAR_VEHICLE_CERTIFICATION_SALE,
  };
};
